<div [ngClass]="fieldItem.meta && fieldItem.meta.groupRowClasses">
        <div [ngClass]="fieldItem.meta && fieldItem.meta.groupInnerRowClasses"
            class="inputs-block-header map-val d-flex align-items-center"
            style="--i: {{fieldItem.level ? fieldItem.level : 0}}"
            (click)="(fieldItem.type !== 'select' && fieldItem.type !== 'editgrid' && fieldItem.type !== 'datagrid') ? toggleBlock.emit(fieldItem) : handleSelectSelection(fieldItem)">
            <i *ngIf="(fieldItem.type !== 'select' && fieldItem.type !== 'editgrid' && fieldItem.type !== 'datagrid')" class="far fa-angle-down block-toggler"></i>
            <i *ngIf="(fieldItem.type === 'select' || fieldItem.type === 'editgrid' || fieldItem.type === 'datagrid')"
                (click)="(fieldItem.type === 'select' || fieldItem.type === 'editgrid' || fieldItem.type === 'datagrid') ? toggleBlock.emit(fieldItem) : null" class="far fa-angle-down block-toggler"></i>
            <i *ngIf="fieldItem.meta.groupTypeClass" [ngClass]="fieldItem.meta && fieldItem.meta.groupTypeClass" class="mr-2 flex-grow-0 " tooltip="{{fieldItem.meta.groupType}}"
            (click)="(fieldItem.type === 'select' || fieldItem.type === 'editgrid' || fieldItem.type === 'datagrid') ? handleSelectSelection(fieldItem) : null"></i>
            <span (click)="(fieldItem.type === 'select' || fieldItem.type === 'editgrid' || fieldItem.type === 'datagrid') ? handleSelectSelection(fieldItem) : null" class="field-item-title" [innerHTML]="fieldItem.meta && fieldItem.meta.texts && fieldItem.meta.texts.name | translate"></span>
            
            <!--<i class="far ml-auto cursor-pointer field-item-visibility"
                [ngClass]="fieldItem.meta && fieldItem.meta.groupEyeClasses"
                (click)="toggleGroupVisibility.emit(fieldItem);$event.stopPropagation();"></i>-->
        </div>
        <ng-container *ngFor="let i of fieldItem.items | filterBy: filter;">
                <field-item-group *ngIf="i.isgroup"
                                [type]="type"
                                [isLtr]="isLtr"
                                [dragSrc]="dragSrc"
                                [hidden]="hidden"
                                [hideFields]="hideFields"
                                [fieldItem]="i"
                                [parentFieldItem]="fieldItem"
                                [lines]="lines"
                                [fieldIndex]="fieldIndex"
                                [rightPrefix]="rightPrefix"
                                [filter]="filter"
                                (showHideField)="showHideField.emit($event)"
                                (deleteSelection)="deleteSelection.emit($event)"
                                (handleEndPointSelection)="handleEndPointSelection.emit($event)"
                                (handleStartPointSelection)="handleStartPointSelection.emit($event)"
                                (addDataTransformation)="addDataTransformation.emit($event)"
                                (toggleBlock)="toggleBlock.emit($event)"
                                (changeGroupMetaAfterNgOnChange)="changeGroupMetaAfterNgOnChange.emit($event)"
                                (changeGroupMetaAfterLineChange)="changeGroupMetaAfterLineChange.emit($event)"
                                (toggleGroupVisibility)="toggleGroupVisibility.emit($event)"
                                style="--i: {{fieldItem.level ? fieldItem.level : 0}}"
                >
                </field-item-group>
                <field-item *ngIf="!i.isgroup"
                        [id]="getSanitizeID(i.field.id || i.field.fieldKey, rightPrefix)"
                        [type]="type"
                        [isLtr]="isLtr"
                        [dragSrc]="dragSrc"
                        [hidden]="hideFields[i.field.id || i.field.fieldKey] && hidden"
                        [hideFields]="hideFields"
                        [fieldItem]="i"
                        [lines]="lines"
                        [rightPrefix]="rightPrefix"
                        (showHideField)="showHideField.emit($event)"
                        (deleteSelection)="deleteSelection.emit($event)"
                        (handleEndPointSelection)="handleEndPointSelection.emit($event)"
                        (handleStartPointSelection)="handleStartPointSelection.emit($event)"
                        style="--i: {{fieldItem.level ? fieldItem.level : 0}}"
                        (addDataTransformation)="addDataTransformation.emit($event)"></field-item>
        </ng-container>
</div>
